import { $t } from "@/lib/i18nHelpers";
import { ListField } from "@/types";

export const systemName = "not_configured";

export const listField: ListField = { value: systemName, text: $t("Not configured") };
